import { base } from './base'

export const selectIsKbsLoaded = state => base(state).isLoaded
